import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { PregledObracunaComponent } from './pregled-obracuna.component';

import { TabsModule } from 'beyond-util';

@NgModule({
  declarations: [PregledObracunaComponent],
  entryComponents: [PregledObracunaComponent],
  exports: [PregledObracunaComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
})
export class PregledObracunaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/pregled-obracuna/pregled-obracuna.module.ts